import sdg01 from '../assets/SDG/E-WEB-Goal-01.png';
import sdg02 from '../assets/SDG/E-WEB-Goal-02.png';
import sdg03 from '../assets/SDG/E-WEB-Goal-03.png';
import sdg04 from '../assets/SDG/E-WEB-Goal-04.png';
import sdg05 from '../assets/SDG/E-WEB-Goal-05.png';
import sdg06 from '../assets/SDG/E-WEB-Goal-06.png';
import sdg07 from '../assets/SDG/E-WEB-Goal-07.png';
import sdg08 from '../assets/SDG/E-WEB-Goal-08.png';
import sdg09 from '../assets/SDG/E-WEB-Goal-09.png';
import sdg10 from '../assets/SDG/E-WEB-Goal-10.png';
import sdg11 from '../assets/SDG/E-WEB-Goal-11.png';
import sdg12 from '../assets/SDG/E-WEB-Goal-12.png';
import sdg13 from '../assets/SDG/E-WEB-Goal-13.png';
import sdg14 from '../assets/SDG/E-WEB-Goal-14.png';
import sdg15 from '../assets/SDG/E-WEB-Goal-15.png';
import sdg16 from '../assets/SDG/E-WEB-Goal-16.png';
import sdg17 from '../assets/SDG/E-WEB-Goal-17.png';
import { getSdgDisplayName } from './sdgs';

/** Official UN SDG icon assets (goals 1–17). */
export const SDG_IMAGES: Record<number, string> = {
  1: sdg01,
  2: sdg02,
  3: sdg03,
  4: sdg04,
  5: sdg05,
  6: sdg06,
  7: sdg07,
  8: sdg08,
  9: sdg09,
  10: sdg10,
  11: sdg11,
  12: sdg12,
  13: sdg13,
  14: sdg14,
  15: sdg15,
  16: sdg16,
  17: sdg17,
};

export function getSdgImage(sdgNumber: number): string | null {
  return SDG_IMAGES[sdgNumber] ?? null;
}

export function getSdgAlt(sdgNumber: number): string {
  const name = getSdgDisplayName(sdgNumber);
  return name ? `SDG ${sdgNumber}: ${name}` : `SDG Goal ${sdgNumber}`;
}
